export enum ColorTextboxClassName {
  Base = "color-textbox",
  Swatch = "color-textbox_swatch",
  Textbox = "color-textbox_textbox",
}
